<template>
  <Table :rows="rows" :fields="fields" :fixedHeight="fixedHeight" invoice>
    <template v-slot:emptyTable>
      <EmptyTable />
    </template>
  </Table>
</template>

<script>
import { invoiceMixins } from '../../../utils/mixins'
import EmptyTable from './EmptyTable.vue'
import Table from '../../common/table/Table'
export default {
  mixins: [invoiceMixins],
  components: {
    Table,
    EmptyTable,
  },
  props: {
    fixedHeight: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mockFields: [
        // { key: 1, label: 'ردیف' },
        { key: 2, label: 'شرح کالا یا خدمات' },
        { key: 3, label: 'تعداد' },
        { key: 4, label: 'مبلغ واحد' },
        { key: 5, label: 'مبلغ کل' },
        { key: 6, label: 'تخفیف' },
        { key: 7, label: 'مبلغ پس از تخفیف' },
        { key: 8, label: 'مالیات' },
        { key: 9, label: 'جمع کل' },
        // { key: 10, label: '' },
      ],
    }
  },
  computed: {
    rows() {
      return this.invoiceList
    },
    fields() {
      return this.mockFields
    },
  },
}
</script>

<style scoped>
::v-deep .table thead th {
  font-size: 12px !important;
  padding: 0.5rem;
}
::v-deep .card {
  box-shadow: 0 0 0 0!important;
}
</style>
